import script from "./SystemConfiguration.vue?vue&type=script&setup=true&lang=js"
export * from "./SystemConfiguration.vue?vue&type=script&setup=true&lang=js"

import "./SystemConfiguration.vue?vue&type=style&index=0&id=119378fb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-119378fb"]])

export default __exports__